import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'banco-list',
	templateUrl: './banco-list.component.html',
	styleUrls: ['./banco-list.component.css'],
})
export class BancoListComponent implements OnInit {
	public title: String;
	public dataGrid: any;

	constructor() {
		this.title = "Bancos";
		
		this.dataGrid = {
			keyGrid: "banco",
			perPage: 10,
			endPoint: "/bancos",
			routeEdit: "/cobro/bancos-edit",
			columsDef: [
				{
					Header: "Nombre",
					Field: "nombre",
					Searchable: true
				}
			]
		};
	}

	ngOnInit() {
		//
	}
}




// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/cobros/banco-list/banco-list.component.ts